import React from "react";
import { default as MuiPopper } from "@mui/material/Popper";

function Popper(props) {
  return <MuiPopper {...props} />;
}

export default Popper;
